import { createThunkRoutine } from 'redux-thunk-routine';
import {
  FETCH_USER_IDENTIFICATIONS,
  FETCH_APPLICATIONS,
  FETCH_CLIENT_SCOPES,
  FETCH_CLIENT_API_KEYS,
} from './action-types';

export const FetchUserIdentificationsRoutine = createThunkRoutine(FETCH_USER_IDENTIFICATIONS);
export const FetchApplicationsRoutine = createThunkRoutine(FETCH_APPLICATIONS);
export const FetchClientScopesRoutine = createThunkRoutine(FETCH_CLIENT_SCOPES);
export const FetchClientAPIKeysRoutine = createThunkRoutine(FETCH_CLIENT_API_KEYS);
